import React, { useEffect, useRef } from 'react'
import { Rect, Text } from 'react-konva'

export const TextTransformer = ({
  source,
  width,
  height,
  opacity,
  extSourceSize,
  scale,
}) => {
  const rectRef = useRef()

  const getRenderedTextWidth = node => {
    const sourceWidth = Number.isFinite(node.attrs.width)
      ? node.attrs.width
      : node.getWidth()
    const renderedWidth = Number.isFinite(extSourceSize?.width)
      ? extSourceSize.width
      : sourceWidth * scale.x

    return Math.max(1, Math.round(renderedWidth))
  }

  useEffect(() => () => {
    Array.from(source.children).forEach(node => {
      node.destroy()
    })
  }, [ source.children ])

  return (
    <>
      {Array.from(source.children).map(node => {
        switch (true) {
          case node.className === 'Rect' && node.attrs.key === 'background': {
            return (
              <Rect
                {...node.attrs}
                listnerCount={1} // Limitation on the number of attendees
                batchUpdate
                width={width}
                height={height}
                opacity={opacity}
                ref={rectRef}
              />
            )
          }
          case node.className === 'Rect' && node.attrs.key === 'rect': {
            return (
              <Rect
                {...node.attrs}
                listnerCount={1} // Limitation on the number of attendees
                batchUpdate
                y={height}
                width={Math.floor(getRenderedTextWidth(node))}
                height={Math.max(height * 0.05, 1)}
                opacity={opacity}
                ref={rectRef}
              />
            )
          }
          case node.className === 'Text' && node.attrs.key === 'clone': {
            return (
              <Text
                {...node.attrs}
                listnerCount={1} // Limitation on the number of attendees
                batchUpdate
                width={getRenderedTextWidth(node)}
                height="auto"
                wrap="word"
                fontSize={Math.round(node.attrs.fontSize * scale.y)}
              />
            )
          }
          case node.className === 'Text' && node.attrs.key === 'text': {
            return (
              <Text
                {...node.attrs}
                listnerCount={1} // Limitation on the number of attendees
                batchUpdate
                width={getRenderedTextWidth(node)}
                height="auto"
                wrap="word"
                fontSize={Math.round(node.attrs.fontSize * scale.y)}
              />
            )
          }
          default: {
            return null
          }
        }
      })}
    </>
  )
}
